<template>
  <div class="wizard px-[20px]">

    <div @click="$router.push('/')" class="flex text-[#BD9135] items-center ml-3 mt-2">
        <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 17L1.56957 10.8258C0.810144 10.0966 0.810144 8.90341 1.56957 8.17424L8 2" stroke="#BD9135" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
        </svg>
        <div class="ml-2">
            Назад
        </div>
    </div>

    <!-- Контент текущего шага -->
    <div v-if="!surveyEndedFlag" class="wizard-content">
        <h2 class="text-white font-bold text-[21px] text-center mb-[10px]">{{ steps[currentStep].header }}</h2>
        <h2 class="text-white font-bold">{{ steps[currentStep].title }}</h2>
      
        <div v-if="steps[currentStep].answerType == 'mark'">
            <input
                v-model="steps[currentStep].answer"
                class="w-full mt-10 h-2 accent-[#BD9135] rounded-lg cursor-pointer"
                id="rating"
                type="range"
                min="0"
                max="10"
                step="1"
            />

            <div class="w-full text-center text-[#BD9135] font-bold text-[24px] mt-4">
                {{ +steps[currentStep].answer }}
            </div>
        </div>
        <div v-if="steps[currentStep].answerType == 'text'">
            <textarea
                v-model="steps[currentStep].answer"
                class="w-full mt-10 p-2 bg-[#252526] outline-none rounded-lg text-white"
                :style="[
                    `border: ${steps[currentStep].answer?.length <= 10 ? '1px solid red' : '1px solid #BD9135'}`
                ]"
                rows="4"
                placeholder="Ваш коментар"
                minlength="10"
            ></textarea>

            <div v-if="steps[currentStep].answer?.length <= 10" class="mt-2">
                <div class="text-[#DA4167]">Щоб пройти далі, введіть коментар не менше 10 символів.</div>
            </div>
        </div>
    </div>
    <div v-else class="wizard-content text-center">
        <h2 class="text-white font-bold text-[21px] mb-[10px]">Опитування завершено!</h2>
        <div class="text-white">Дякуємо за участь! Твої відповіді допоможуть нам покращити нашу роботу та підтримати вас у майбутніх матчах.</div>

        <div class="flex justify-center">
            <img src="@/mobileApp/assets/survey-end.webp" alt="Thank You" class="mt-6 w-[150px] h-[150px]"/>
        </div>
    </div>

    <!-- Кнопки навигации -->
    <div v-if="!surveyEndedFlag" class="wizard-actions">
      <button class="bg-[#BD9135] rounded-[9px] text-white px-3 py-3 w-[49%] text-base font-semibold mt-6 mx-auto text-center" @click="prevStep" :disabled="isFirstStep">Назад</button>

      <div v-if="steps[currentStep].answerType == 'text'" class="w-[49%]">
          <button class="bg-[#BD9135] rounded-[9px] text-white px-3 py-3 w-[100%] text-base font-semibold mt-6 mx-auto text-center" v-if="!isLastStep && steps[currentStep].answer?.length >= 10" @click="nextStep">Далі</button>
          <button class="bg-[#BD9135] rounded-[9px] text-white px-3 py-3 w-[100%] text-base font-semibold mt-6 mx-auto text-center opacity-50" v-else-if="!isLastStep && steps[currentStep].answer?.length <= 10">Далі</button>
          <button class="bg-[#BD9135] rounded-[9px] text-white px-3 py-3 w-[100%] text-base font-semibold mt-6 mx-auto text-center" v-else-if="steps[currentStep].answer?.length >= 10" @click="saveSurvey">Завершити</button>
          <button class="bg-[#BD9135] rounded-[9px] text-white px-3 py-3 w-[100%] text-base font-semibold mt-6 mx-auto text-center opacity-50" v-else-if="steps[currentStep].answer?.length <= 10">Завершити</button>
      </div>
      <div v-else class="w-[49%]">
          <button class="bg-[#BD9135] rounded-[9px] text-white px-3 py-3 w-[100%] text-base font-semibold mt-6 mx-auto text-center" v-if="!isLastStep" @click="nextStep">Далі</button>
          <button class="bg-[#BD9135] rounded-[9px] text-white px-3 py-3 w-[100%] text-base font-semibold mt-6 mx-auto text-center" v-else @click="saveSurvey">Завершити</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { createAfterMatchSurvey, checkAfterMatchSurveyExists } from "@/mobileApp/services/apiRequests";
import { uuid } from "vue3-uuid";
import { useRoute } from "vue-router";
import { useMainStore } from "@/mobileApp/store/mainStore";

export default {
    name: 'AftermatchSurvey',

    setup() {
        const defaultSteps = [
            { 
                id: 1, 
                header: "Крок 1",
                title: "Як відчував себе фізично та психічно перед грою?(1-10)", 
                answerType: "mark",
                answer: null
            },
            { 
                id: 2, 
                header: "Крок 2",
                title: "Як відчував себе фізично та психічно під час гри?(1-10)", 
                answerType: "mark",
                answer: null
            },
            {
                id: 3,
                header: "Крок 3",
                title: "Власна гра в ОБОРОНІ, що вийшло, що ні, чому?",
                answerType: "text",
                answer: null
            },
            {
                id: 4,
                header: "Крок 4",
                title: "Власна гра в АТАЦІ, що вийшло, що ні, чому?",
                answerType: "text",
                answer: null
            },
            {
                id: 5,
                header: "Крок 5",
                title: "Які індивідуальні установки виконав, а які ні, чому?",
                answerType: "text",
                answer: null
            },
            {
                id: 6,
                header: "Крок 6",
                title: "Найважчий момент особисто для тебе під час гри та чому?",
                answerType: "text",
                answer: null
            },
            {
                id: 7,
                header: "Крок 7",
                title: "Найважчий момент для команди під час гри та чому?",
                answerType: "text",
                answer: null
            },
            {
                id: 8,
                header: "Крок 8",
                title: "Ситуації у грі після яких ти маєш питання (конкретно хвилини...)?",
                answerType: "text",
                answer: null
            },
            {
                id: 9,
                header: "Крок 9",
                title: "Оцінка власної гри?(1-10)",
                answerType: "mark",
                answer: null
            },
        ];

        const u19Steps = [
            { 
                id: 1, 
                header: "Крок 1",
                title: "Як відчував себе фізично перед грою?(1-10)", 
                answerType: "mark",
                answer: null
            },
            { 
                id: 2, 
                header: "Крок 2",
                title: "Як відчував себе психічно перед грою?(1-10)", 
                answerType: "mark",
                answer: null
            },
            { 
                id: 3, 
                header: "Крок 3",
                title: "Як відчував себе фізично під час гри?(1-10)", 
                answerType: "mark",
                answer: null
            },
            { 
                id: 4, 
                header: "Крок 4",
                title: "Як відчував себе психічно під час гри?(1-10)", 
                answerType: "mark",
                answer: null
            },
            {
                id: 5,
                header: "Крок 5",
                title: "По 2-3 ВДАЛІ та НЕВДАЛІ ситуації в ОБОРОНІ (вказати конкретно хвилини з гри)",
                answerType: "text",
                answer: null
            },
            {
                id: 6,
                header: "Крок 6",
                title: "По 2-3 ВДАЛІ та НЕВДАЛІ ситуації в АТАЦІ (вказати конкретно хвилини з гри)",
                answerType: "text",
                answer: null
            },
            {
                id: 7,
                header: "Крок 7",
                title: "Які індивідуальні установки виконав, а які ні, чому?",
                answerType: "text",
                answer: null
            },
            {
                id: 8,
                header: "Крок 8",
                title: "Найважчий момент особисто для тебе під час гри та чому?",
                answerType: "text",
                answer: null
            },
            {
                id: 9,
                header: "Крок 9",
                title: "Найважчий момент для команди під час гри та чому?",
                answerType: "text",
                answer: null
            },
            {
                id: 10,
                header: "Крок 10",
                title: "Ситуації у грі після яких ти маєш питання (конкретно хвилини...)?",
                answerType: "text",
                answer: null
            },
            {
                id: 11,
                header: "Крок 11",
                title: "Оцінка власної гри?(1-10)",
                answerType: "mark",
                answer: null
            },
        ];

        const isU19Group = (groupName = '') => {
            return (groupName || '').toLowerCase().includes('u19');
        };

        const steps = ref([...defaultSteps]);

        const surveyEndedFlag = ref(false);

        const currentStep = ref(0);

        const isFirstStep = computed(() => currentStep.value === 0);
        const isLastStep = computed(() => currentStep.value === steps.value.length - 1);

        const nextStep = () => {
            if (!isLastStep.value) {
                currentStep.value++;
            }
        };

        const prevStep = () => {
            if (!isFirstStep.value) {
                currentStep.value--;
            }
        };

        const goToStep = (index) => {
            if (index >= 0 && index < steps.value.length) {
                currentStep.value = index;
            }
        };

        const route = useRoute();
        const store = useMainStore();

        const saveSurvey = async () => {
            try {
                await createAfterMatchSurvey({
                    survey_id: uuid.v4(),
                    training_id: route.params.trainingId, // Assuming you get training_id from route params
                    group_id: store.student.group_id,
                    student_id: store.student.student_id,

                    student_name: store.student.name,
                    student_surname: store.student.surname,

                    steps: steps.value,
                    status: 'completed'
                });
                console.log("Survey saved successfully");
                surveyEndedFlag.value = true;
            } catch (error) {
                console.error("Error saving survey:", error);
            }
        };

        onMounted(async () => {
            try {
                if (!store.group?.name && store.student?.group_id) {
                    await store.getGroupData();
                }

                steps.value = isU19Group(store.group?.name)
                    ? u19Steps.map(step => ({ ...step }))
                    : defaultSteps.map(step => ({ ...step }));

                const response = await checkAfterMatchSurveyExists(store.student.student_id, route.params.trainingId);
                console.log("response", response);
                console.log("store.student.student_id", store.student.student_id);
                console.log("route.params.trainingId", route.params.trainingId);
                if (response?.data?.survey) {
                    surveyEndedFlag.value = true;
                }
            } catch (error) {
                console.error("Error checking survey existence:", error);
            }
        });

        return {
            steps,
            currentStep,
            isFirstStep,
            isLastStep,
            nextStep,
            prevStep,
            goToStep,
            surveyEndedFlag,
            saveSurvey
        };
    }
}
</script>

<style lang="scss" scoped>
    .wizard {
        max-width: 500px;
        margin: auto;
        font-family: sans-serif;
    }

    .wizard-steps {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
    }

    .wizard-step {
        padding: 10px 15px;
        border-radius: 8px;
        cursor: pointer;
        background: #eee;
        transition: background 0.3s;
    }

    .wizard-step.active {
        background: #42b983;
        color: white;
    }

    .wizard-content {
        margin: 20px 0;
        padding: 15px;
        border-radius: 8px;
    }

    .wizard-actions {
        display: flex;
        justify-content: space-between;
    }
</style>